import Vue from "vue";
import Vuex from "vuex";
import VueRouter from "vue-router";
import Axios from "axios";
import NProgress from "nprogress";
import OutdatedBrowser from "outdated-browser-rework";
import jQuery from "jquery";
import Fancybox from "@fancyapps/fancybox";
import Slick from "slick-carousel";

(<any>window).Vue = Vue;
(<any>window).Vuex = Vuex;
(<any>window).VueRouter = VueRouter;
(<any>window).Axios = Axios;
(<any>window).NProgress = NProgress;
(<any>window).OutdatedBrowser = OutdatedBrowser;
(<any>window).$ = (<any>window).jQuery = jQuery;
(<any>window).Fancybox = Fancybox;
(<any>window).Slick = Slick;